module.exports = __webpack_public_path__ + "media/slide3/contractMediaSlide3Part2vs-298de722.png";